import React, { useEffect, useState } from 'react';

import { OFFERS_SORTING_FIELD } from 'pages/Dashboard/steps/AcceptOffer/AcceptAutomatedOffer/OffersTableWrapper/offersTableWrapper.constants';
import { OffersPageFilters } from 'pages/Dashboard/steps/AcceptOffer/AcceptAutomatedOffer/OffersTableWrapper/offersTableWrapper.types';
import useMobileCheck from 'hooks/useMobileCheck';
import { OfferDto } from 'api/AutomatedOffersApi';
import OffersTableMobile from 'pages/Dashboard/steps/AcceptOffer/AcceptAutomatedOffer/OffersTableWrapper/OffersTableMobile/OffersTableMobile';
import OffersTable from 'pages/Dashboard/steps/AcceptOffer/AcceptAutomatedOffer/OffersTableWrapper/OffersTable/OffersTable';
import { OffersTableColumnsTitle } from 'pages/Dashboard/steps/AcceptOffer/AcceptAutomatedOffer/OffersTableWrapper/offersTableWrapper.enums';

export interface OffersTableWrapperProps {
  loanOffers: OfferDto[];
  onAcceptOffer: (loanOffer: OfferDto) => void;
  isDisabled: boolean;
}

const OffersTableWrapper = ({ loanOffers, onAcceptOffer, isDisabled }: OffersTableWrapperProps) => {
  const [sortedLoanOffers, setSortedLoanOffers] = useState<OfferDto[]>(loanOffers);
  const [filters, setFilters] = useState<OffersPageFilters>({
    sortField: OFFERS_SORTING_FIELD[OffersTableColumnsTitle.MonthlyPayments]!,
    isSortDesc: false,
  });
  const isMobile = useMobileCheck();

  useEffect(() => {
    const sortedOffers = [...loanOffers].sort((a, b) => {
      if (filters.isSortDesc) {
        return Number(b[filters.sortField]) - Number(a[filters.sortField]);
      }

      return Number(a[filters.sortField]) - Number(b[filters.sortField]);
    });

    setSortedLoanOffers(sortedOffers);
  }, [filters, loanOffers]);

  const updateTableSort = (sortField?: keyof OfferDto) => {
    if (!sortField) {
      return;
    }

    const isSortDesc = filters.sortField === sortField ? !filters.isSortDesc : true;

    setFilters({ sortField: sortField, isSortDesc: isSortDesc });
  };

  return isMobile ? (
    <OffersTableMobile
      offers={sortedLoanOffers}
      onAcceptOffer={onAcceptOffer}
      isDisabled={isDisabled}
      filters={filters}
      updateTableSort={updateTableSort}
    />
  ) : (
    <OffersTable
      offers={sortedLoanOffers}
      onAcceptOffer={onAcceptOffer}
      isDisabled={isDisabled}
      filters={filters}
      updateTableSort={updateTableSort}
    />
  );
};

export default OffersTableWrapper;
